import { Components, Theme } from "@mui/material/styles";

export const MuiAlert: Components<Theme>["MuiAlert"] = {
  styleOverrides: {
    root: {
      width: "100%",
      alignItems: "center",
    },

    standardSuccess: {
      backgroundColor: "#EDF7ED",
      color: "#1E4620",
    },

    standardError: ({ theme }) => ({
      backgroundColor: "#FAEDE5",
      color: theme.palette.common.black,
    }),

    standardWarning: ({ theme }) => ({
      backgroundColor: "#FFF8E1",
      color: theme.palette.common.black,
    }),

    standardInfo: ({ theme }) => ({
      backgroundColor: "#F3F5FA",
      color: theme.palette.common.black,
    }),
  },
};
